import { render, staticRenderFns } from "./DynamicHouse.vue?vue&type=template&id=12c9df1a&scoped=true"
import script from "./DynamicHouse.vue?vue&type=script&lang=js"
export * from "./DynamicHouse.vue?vue&type=script&lang=js"
import style0 from "./DynamicHouse.vue?vue&type=style&index=0&id=12c9df1a&prod&lang=css"
import style1 from "./DynamicHouse.vue?vue&type=style&index=1&id=12c9df1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8432db7643500554ffee61cb980ae8ea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c9df1a",
  null
  
)

export default component.exports